import { render } from "./ConfirmarCuenta.vue?vue&type=template&id=b9a060d2"
import script from "./ConfirmarCuenta.vue?vue&type=script&lang=js"
export * from "./ConfirmarCuenta.vue?vue&type=script&lang=js"

import "./ConfirmarCuenta.vue?vue&type=style&index=0&id=b9a060d2&lang=css"

import exportComponent from "C:\\Users\\Desarrollo\\Documents\\Inventarios 2.0\\Technosoft.Inventarios.v2\\Technosoft.Inventarios.v2.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__